<template>
  <div 
    v-if="index < num && id" 
    class="search-order-list-item-content"
    @click.stop="onClick"
  >
    <div  class="search-order-list-item-content-text">
      <div class="search-order-list-item-content-invoice-text">
        <span class="search-order-list-title">{{ id }}</span>
        <div v-if="data.bookingAgentBpVO && data.bookingAgentBpVO.bpName">
          <el-tooltip class="item" effect="dark" :content="data.bookingAgentBpVO.bpName" placement="right">
            <div class="search-order-list-ellipsis" >
                订舱代理：{{ data.bookingAgentBpVO && data.bookingAgentBpVO.bpName }}
            </div>
          </el-tooltip>
        </div>
      </div>
      <div class="search-order-list-item-user-text">
        <span v-if="data.operationUserVO && data.operationUserVO.userName">（操作：{{ data.operationUserVO && data.operationUserVO.userName }}）</span>
        <span v-if="data.documentUserVO && data.documentUserVO.userName">（单证：{{ data.documentUserVO && data.documentUserVO.userName }}）</span>
        <span v-if="data.customerServiceUserVO && data.customerServiceUserVO.userName">（客服：{{ data.customerServiceUserVO && data.customerServiceUserVO.userName }}）</span>
      </div>
    </div>
    <div class="search-order-list-item-content-button-box">
      <div class="search-order-list-item-content-button">
      <el-button class="button--normal">{{ data.orderStatusVO && data.orderStatusVO.name }}</el-button>
    </div>
    </div>
  </div>
</template>
<script>
import { BASE_URL } from '@yld/yun-utils-host'

export default {
  name: 'List',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    },
    num: {
      type: Number,
      default: 3
    },
    dataType: {
      type: String,
      default: ''
    }
  },
  computed: {
    id() {
      if(this.dataType === 'orderContainerNo'){
        return this.data['orderContainerNos'].join(',')
      }
      return this.data[this.dataType]
    },
  },
  methods: {
    onClick() {
      if (this.$appId === '90010') {
        this.$router.push(`/${this.$appId}/orderdetail/${this.data.orderId}`)
      } else {
        const HOME_WORK = BASE_URL.HOME_WORK
        window.open(HOME_WORK + `/90010/orderdetail/${this.data.orderId}`, '_blank')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .search-order-list-item-content {
    flex: 1;
    display: flex;
    &:not(:last-child) {
      border-bottom: 1px solid #e1e1e1;
    }
    &:hover {
      background: #f1f0f0;
    }
    .search-order-list-item-content-text {
      border-right: 1px solid #e1e1e1;
      display: flex;
      span {
        font-size: 12px;
        color: #333;
      }
    }
    .search-order-list-item-content-button {
      .el-button:hover, .el-button:focus {
        background: none;
        border-color: var(--geek-color-primary);
      }
    }
    .search-order-list-item-content-invoice-text{
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-right: 1px solid #e1e1e1;
      width: 200px;
      span {
        height: 25px;
        line-height: 25px;
        display: inline-block;
        display: flex;
        justify-content: center;
      }
      div {
        height: 25px;
        line-height: 25px;
      }
      .search-order-list-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 200px;
        display: block;
        text-align: center;
      }
    }
    .search-order-list-item-content-button-box{
      display: flex;
      justify-content: center;
      align-items: center;
      padding:0 4px;
      width: 100%;
    }
    .search-order-list-ellipsis{
      width: 195px;
      font-size: 12px;
      padding-left: 8px;
      overflow:hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow:ellipsis;
    }
  }
</style>
<style lang="scss">
  .search-order-list-item-content {
    .el-button--small {
      padding: 4px 8px;
    }
  }
  .search-order-list-item-user-text{
    width: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    span {
      display: inline-block;
      height: 25px;
      line-height: 25px;
      max-width: 150px
      ;
    &:not(:last-child) {
      border-bottom: 1px solid #e1e1e1;
    }
  }

  }
</style>